const adTypes = [
    {
        id: 1,
        name: 'Small Ad',
        description: 'Perfect for small emplacements',
    },
    {
        id: 2,
        name: 'Medium Ad',
        description: 'Published at many emplacements',
    },
    {
        id: 3,
        name: 'Large Ad',
        description: 'Located a great emplacements',
    },
    {
        id: 4,
        name: 'Extra Large Ad',
        description: 'Extended for more graphic elements',
    },
];

export default adTypes;
